import {Injectable} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LayerUtilService} from './layer-util.service';
import {SpatialUtilService} from '../services/spatial-util.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class ClippingLayerService {
    private readonly layerId = 'clippingFeatureLayer_layer';

    private readonly layerSelector = `#${this.layerId}`;

    private readonly featureClass = 'clipping';

    private readonly featureIdAttrName = this.layerUtilService.getFeatureIdAttrName(this.featureClass);

    private readonly featureTypeAttrName = this.layerUtilService.getFeatureTypeAttrName(this.featureClass);

    private svgStyle: string;

    private trustedSvgStyle: SafeHtml;

    constructor(
        private domSanitizer: DomSanitizer,
        private layerUtilService: LayerUtilService,
        private spatialUtilService: SpatialUtilService
    ) {}

    getSvgStyle(): SafeHtml {
        const scaleFactor = this.layerUtilService.getPixelScaleFactor();
        if (scaleFactor === 0) {
            return '';
        }

        const newSvgStyle = [
            `${this.layerSelector} path[${this.featureTypeAttrName}="1"] {
                stroke: rgb(0,112,256);
                stroke-opacity: 1.0;
                stroke-width: 1.2;
                fill: rgb(${this.spatialUtilService.getMapBackground() === 'white' ? '255,255,255' : '0,0,0'});
                fill-opacity: 1;
            }`,
            `${this.layerSelector} path[${this.featureTypeAttrName}="2"] {
                stroke: rgb(0,112,256);
                stroke-opacity: 1.0;
                stroke-width: 1.2;
                fill: none;
            }`
        ].join('\n');

        if (newSvgStyle === this.svgStyle) {
            return this.trustedSvgStyle;
        }

        this.svgStyle = newSvgStyle;

        this.trustedSvgStyle = this.domSanitizer.bypassSecurityTrustHtml(this.svgStyle);

        return this.trustedSvgStyle;
    }

    init() {
        const clippingFeatureLayer = this.spatialUtilService.getClippingMapLayer();

        this.layerUtilService.addLayerEventHandler(clippingFeatureLayer, 'graphic-node-add', (evt: {graphic: any; node: any}) => {
            const featureId = evt.graphic.attributes.id;
            evt.node.setAttribute('id', this.layerUtilService.getFeatureNodeId(this.featureClass, featureId));
            evt.node.setAttribute(this.featureTypeAttrName, `${evt.graphic.attributes.type}`);
            evt.node.setAttribute(this.featureIdAttrName, `${featureId}`);
            this.layerUtilService.setSelectedAttr(evt.node, this.featureClass, featureId);
        });

        this.layerUtilService.addLayerEventHandler(clippingFeatureLayer, 'edits-complete', () => {
            const clippingIds = this.spatialUtilService.getClippingGraphics().map((g: any) => g.attributes.id);

            document.querySelectorAll(`${this.layerSelector} path[${this.featureIdAttrName}]`).forEach(path => {
                const clippingId = parseInt(path.getAttribute(this.featureIdAttrName));
                if (!clippingIds.includes(clippingId)) {
                    path.parentNode.removeChild(path);
                }
            });
        });

        this.layerUtilService.addLayerEventHandler(clippingFeatureLayer, 'mouse-over', (evt: any) => {
            this.layerUtilService.onMouseOver(this.featureClass, evt);
        });

        this.layerUtilService.addLayerEventHandler(clippingFeatureLayer, 'mouse-out', (evt: any) => {
            this.layerUtilService.onMouseOut(this.featureClass, evt);
        });

        return clippingFeatureLayer;
    }
}
